<template>
    <div>
        <vx-file-upload
            v-model="localValue"
            v-bind="$attrs"
            v-on="listeners"
            :allowTypes="['csv']"
        />
        <div class="w-full flex justify-end">
            <csv-parse-result-list :files="files" :show="requiredProps.any()" />
        </div>
    </div>
</template>

<script>
import CsvParseResultList from './CsvParseResultList.vue'
export default {
    name: 'vx-csv-uploader',
    components: { CsvParseResultList },
    props: {
        value: {
            type: Array
        },
        requiredProps: {
            type: Array,
            default: () => [],
            validator: (v) => v.all((item) => typeof item === 'string')
        }
    },
    data() {
        return {
            files: []
            /* files: [
                {
                    file: File,
                    records: records
                }
            ]*/
        }
    },
    computed: {
        listeners() {
            var listeners = {
                ...this.$listeners
            }
            delete listeners.input
            return listeners
        },
        currentFiles() {
            return this.files.map((f) => f.file)
        },
        currentRecords() {
            return this.files.selectMany((f) => f.records)
        },
        localValue: {
            get() {
                return this.currentFiles
            },
            set(newFiles) {
                this.parseFiles(newFiles)
            }
        }
    },
    methods: {
        async parseFiles(files) {
            if (!files || !files.any()) {
                this.files = []
                this.$emit('input', this.currentRecords)
                return
            }
            try {
                this.loading = true
                var newFiles = []
                for (const file of files) {
                    var duplicate = newFiles.first((existing) =>
                        this.checkIsFileSame(existing.file, file)
                    )
                    if (duplicate) {
                        continue
                    }
                    var current = this.files.first((existing) =>
                        this.checkIsFileSame(existing.file, file)
                    )
                    if (current) {
                        newFiles.push(current)
                        continue
                    }

                    var parsedResults = await this.parseRecordsForFile(file)
                    newFiles.push({
                        file,
                        ...parsedResults
                    })
                }
                this.files = newFiles
                this.$emit('input', this.currentRecords)
            } catch (err) {
                this.notifyError('Invalid CSV', 'There was a problem with the uploaded csv file.')
            } finally {
                this.loading = false
            }
        },
        filterInvalidRecords(allRecords) {
            var totalRecords = allRecords.length
            var errors = []
            if (!this.requiredProps.any()) {
                return {
                    records: allRecords,
                    totalRecords,
                    errors
                }
            }

            var records = []
            allRecords.forEach((record, index) => {
                try {
                    var mappedRecord = this.mapRequiredProps(record)
                    records.push(mappedRecord)
                } catch (error) {
                    errors.push({
                        rowNumber: index + 1,
                        message: error
                    })
                }
            })
            return {
                records,
                totalRecords,
                errors
            }
        },
        mapRequiredProps(record) {
            this.requiredProps.forEach((requiredProp) => {
                if (record[requiredProp] != null) {
                    return
                }
                var existingProp = Object.keys(record).first(
                    (key) => requiredProp.compareIgnore(key) === 0
                )
                if (!existingProp || !record[existingProp]) {
                    throw `Missing Required Column: "${requiredProp}"`
                }
                var value = record[existingProp]
                delete record[existingProp]
                record[requiredProp] = value
            })
            return record
        },
        async parseRecordsForFile(file) {
            if (!file) {
                return []
            }
            var allRecords = await file.file.readCsvAsBinaryString()
            return {
                file,
                ...this.filterInvalidRecords(allRecords)
            }
        },
        checkIsFileSame(fileA, fileB) {
            return (
                fileA.name == fileB.name &&
                fileA.lastModified == fileB.lastModified &&
                fileA.size == fileB.size
            )
        }
    }
}
</script>

<style lang="scss" scoped></style>
